/**
 * @fileoverview GET handler for the "/engagement/landing_page_data" endpoint
 */
import fetch from "@lib/fetch";

import type { LandingPageErrors } from "../engagementLandingPagesData";
import { createGetFetcherFunctionWithShadowError, reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementLandingPageData } from "./constants";
import type { EngagementLandingPageDataResult } from "./types";

export const getEngagementLandingPageData = reactQueryFetcherAdapter(
  engagementLandingPageData,
  createGetFetcherFunctionWithShadowError<LandingPageErrors>()(
    (
      signal: AbortSignal,
      { appGroupId, landingPageBsonId }: { appGroupId: string; landingPageBsonId: string }
    ): Promise<EngagementLandingPageDataResult> => {
      return fetch(
        "/engagement/landing_page_data",
        "GET",
        { landing_page_bson_id: landingPageBsonId, app_group_id: appGroupId },
        { signal }
      );
    }
  )
);
